import script from "./CvStructuredListHeading.vue?vue&type=script&setup=true&lang=js"
export * from "./CvStructuredListHeading.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__